export const INTEGRATION_OVERVIEW_TAB = 'integration_overview'
export const INBOUND_TAB = 'inbound'
export const OUTBOUND_TAB = 'outbound'
export const SETTINGS_TAB = 'settings'
export const SHIPPER_CONFIG_TABS = [
  {
    tabId: INTEGRATION_OVERVIEW_TAB,
    label: 'Integration Overview',
  },
  {
    tabId: INBOUND_TAB,
    label: 'Inbound',
  },
  {
    tabId: OUTBOUND_TAB,
    label: 'Outbound',
  },
  {
    tabId: SETTINGS_TAB,
    label: 'Settings',
  },
]
